<template>
<div>
    <!-- <h4 class="section-title">{{temp_text}}</h4> -->

    <div class="input-content d-flex  justify-content-center align-items-center ml-3 no-margin" style="min-width: 240px; max-width:400px; width: 100%">
		<label class="mr-2 green">Agency:</label>
			<v-select :searchable="true" track-by="name" label="name" v-model="agency" :options="agencies" class="green green-dark bg-gray v-select-no-height" single @input="organizationChanged($event)">
                <template #selected-option="agency">
                    <div style="display: flex; align-items: baseline">
                       {{agency.name}}
                    </div>
                </template>
                <template slot="option" slot-scope="agencies">
                    <span> {{agencies.name }} </span>
                    
                </template> 
			</v-select>
	</div>
    <div v-if="agency!=''">
        <keep-alive>
            <router-view></router-view>

        </keep-alive>
        <!-- <provider-list v-if="agency!=''" :agency="agency" @organizationChanged="organizationChanged" :AgencyView="AgencyView"></provider-list> -->
        <!-- <admin-organization-detail-component :agency="agency" @organizationChanged="organizationChanged" :AgencyView="AgencyView"></admin-organization-detail-component> -->
    </div>
 
</div>

</template>
<script>
import { EventBus } from './../../event_bus.js';
import AdminOrganizationDetailComponent from '../admin/organization/AdminOrganizationDetailComponent.vue';
export default {
    components : {
        AdminOrganizationDetailComponent
    },
    data: function() {
        return{
            AgencyView:true,
            agencies:[],
            agency: '',
            temp_text: 'Please Choose From Organization List'
        }
    },
    watch:{
        '$route.params': {
            handler: function(search) {
                if(search && search[0]){
                    let params = search[0].split('/')
                    if(params[1] && (params[1] != '' || params[1] != '/') ){
                        this.$router.push({ name :'csm.providers.info', params : { agency_id : params[0], tab_section: params[1]}});
                        
                    }else{
                         this.$router.push({ name :'csm.providers.index' });

                    }
                }
            },
            deep: true,
            immediate: true
        },
        agency:{
            deep:true,
            handler(newwal){
                 if(this.agency.length>1){
                    this.agency.shift();
                }
                if(newwal.length === 0){
                    this.$router.push({ name :'csm.providers.index'});
                    this.temp_text = 'Please Choose From Organization List'
                }else{
                    this.temp_text = newwal.name + ' - Providers'
                }
            }
        }
    },
    created : function(){
        this.getAgencies();
    },
    methods: {
        getAgencies: function(){
            var params = {
            filters : {
                per_page : 9999,
                to_select : 1,
            }
           }
            this.$store.dispatch('getOrganizations', params).then((res) => {
                this.agencies = res.data.data
                // Now we check route param. If we have agency_id, we use it to show providers
                if(this.$route.params.agency_id != ''){
                    for( let i in this.agencies){
                        if(this.agencies[i].id == this.$route.params.agency_id){
                            this.agency = this.agencies[i]
                        }
                    }
                }

         }).catch((error) => {
            console.log(error);
         });


        },
        organizationChanged: function(event){
            if(event){
                let agency_tab_redirect =  window.location.pathname.split('/')
                if(agency_tab_redirect.length == 5){
                    //here we add tab pa
                    this.$router.push({ name :'csm.providers.info', params : { agency_id : event.id , tab_section:agency_tab_redirect[4] }});
                }else{
                    this.$router.push({ name :'csm.providers.info', params : { agency_id : event.id }});
                }
                EventBus.$emit('organizationChanged')
            }
		},
    }
}
</script>



// WEBPACK FOOTER //
// src/components/csp/CustomerSuccessProviderList.vue